import { config } from '@services/config';
import { InsuredLocationsSearchResponse } from '@lio/api-types';
import { getInsuredLocationsQuery } from '@services/customer/insuredLocations/insuredLocations.helpers';
import { InsuredLocationsQueryParams } from '@services/customer/insuredLocations/insuredLocations.types';
import { customerQueryKey } from '@services/customer/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useInsuredLocations = (queryParams: InsuredLocationsQueryParams) => {
  const client = useClient();
  const { customerId } = queryParams;
  let url = `customer/${customerId}/insured-location`;
  const queryStr = getInsuredLocationsQuery(queryParams);
  if (queryStr) {
    url = `${url}?${queryStr}`;
  }
  const result = useQuery<InsuredLocationsSearchResponse, Error>({
    queryKey: customerQueryKey.searchLocations(queryParams),
    queryFn: () => client.get(url).json<InsuredLocationsSearchResponse>(),
    enabled: !!customerId,
    refetchOnWindowFocus: false,
    ...config,
  });
  return {
    ...result,
    insuredLocations: result.data,
    refetchInsuredLocations: result.refetch,
  };
};
